import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';

const SFSlider = withStyles({
    root: {},
    thumb: {
        backgroundColor: 'rgb(208, 26, 98)',
    },
    active: {},
    valueLabel: {
        color: 'rgb(208, 26, 98)',
    },
    track: {
      backgroundColor: 'rgb(208, 26, 98)',
    },
    rail: {
      backgroundColor: 'rgb(208, 26, 98)',
    },
    mark: {},
    markActive: {},
})(Slider);

export default SFSlider